// extracted by mini-css-extract-plugin
export default {"wrapper":"hJ","content":"iJ","firstSection":"jJ","text":"kJ","table":"lJ","tableText":"mJ","row":"nJ","column_2":"oJ","column_1":"pJ","column_3":"qJ"};
    if(module.hot) {
      // 1713809678536
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  